/** Typed access to environment configuration. Only VITE_* keys are exposed to the browser. */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL?.trim() || '',
  aiBackendUrl: (import.meta.env.VITE_AI_BACKEND_URL?.trim() || '').replace(/\/+$/, ''),
  serverTimezone: import.meta.env.VITE_SERVER_TIMEZONE?.trim() || 'America/New_York',
  commentRefreshMs: Number(import.meta.env.VITE_COMMENT_REFRESH_TIMEOUT) || 15000,
  /** Google reCAPTCHA v2 site key for the sign-up form (public by design). Empty = captcha widget hidden. */
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY?.trim() || '',
  spaces: {
    bucket: import.meta.env.VITE_DIGITALOCEAN_S3_BUCKET?.trim() || '',
    endpoint: import.meta.env.VITE_DIGITALOCEAN_ENDPOINT?.trim() || '',
    publicUrl: (import.meta.env.VITE_DIGITALOCEAN_PUBLIC_URL?.trim() || '').replace(/\/+$/, ''),
    accessKey: import.meta.env.VITE_DIGITALOCEAN_ACCESS_KEY?.trim() || '',
    secretKey: import.meta.env.VITE_DIGITALOCEAN_SECRET_KEY?.trim() || '',
  },
} as const
